import { useNavigate } from 'react-router-dom';
import { ChevronRight, BarChart3, FolderKanban, Users, Package, Calendar, ShoppingCart, TrendingUp, Settings, Monitor, LogOut, Leaf, Handshake, CalendarClock } from 'lucide-react';

export default function MobileMorePage() {
  const navigate = useNavigate();

  const groups = [
    {
      title: 'R&D',
      items: [
        { icon: BarChart3, bg: '#5856d6', label: 'R&D Dashboard', subtitle: 'Overview & metrics', path: '/mobile/rd' },
        { icon: FolderKanban, bg: '#5856d6', label: 'Projects', subtitle: 'View R&D projects', path: '/mobile/rd/projects' },
        { icon: Package, bg: '#5856d6', label: 'Pending Items', subtitle: 'Items awaiting approval', path: '/mobile/rd/pending-items' },
        { icon: Leaf, bg: '#34c759', label: 'Nutrition', subtitle: 'Nutrition database', path: '/rd/nutrition', desktop: true },
      ]
    },
    {
      title: 'CRM',
      items: [
        { icon: BarChart3, bg: '#007aff', label: 'CRM Dashboard', subtitle: 'Sales overview', path: '/mobile/crm' },
        { icon: TrendingUp, bg: '#007aff', label: 'Opportunities', subtitle: 'Sales pipeline', path: '/mobile/crm/opportunities' },
        { icon: Users, bg: '#007aff', label: 'Customers', subtitle: 'Customer list', path: '/mobile/crm/customers' },
        { icon: Handshake, bg: '#007aff', label: 'Brokers', subtitle: 'Broker management', path: '/mobile/crm/brokers' },
      ]
    },
    {
      title: 'Inventory',
      items: [
        { icon: Package, bg: '#ff9500', label: 'Items', subtitle: 'All items & BOMs', path: '/mobile/items' },
        { icon: CalendarClock, bg: '#ff9500', label: 'Planning', subtitle: 'Production planning', path: '/mobile/planning' },
        { icon: ShoppingCart, bg: '#ff9500', label: 'Purchase Orders', subtitle: 'Inbound orders', path: '/mobile/purchase-orders' },
        { icon: TrendingUp, bg: '#ff9500', label: 'Sales Orders', subtitle: 'Outbound orders', path: '/mobile/sales-orders' },
      ]
    },
    {
      title: 'System',
      items: [
        { icon: Settings, bg: '#8e8e93', label: 'Settings', subtitle: 'App info & preferences', path: '/mobile/settings' },
        { icon: Monitor, bg: '#636366', label: 'Desktop View', subtitle: 'Switch to full desktop app', path: '/' },
      ]
    }
  ];

  return (
    <div className="mobile-page">
      {/* User Card */}
      <div className="mobile-user-card">
        <div className="mobile-user-avatar">JD</div>
        <div>
          <div className="mobile-user-name">John Doe</div>
          <div className="mobile-user-role">Plant Manager</div>
        </div>
      </div>

      {groups.map((group) => (
        <div key={group.title} className="mobile-menu-group">
          <div className="mobile-menu-group-title">{group.title}</div>
          <div className="mobile-menu-list">
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.label}
                  className="mobile-menu-item"
                  onClick={() => navigate(item.path)}
                >
                  <div className="mobile-menu-item-icon" style={{ background: item.bg }}>
                    <Icon size={16} />
                  </div>
                  <div className="mobile-menu-item-content">
                    <div className="mobile-menu-item-title">
                      {item.label}
                      {item.desktop && <span style={{ fontSize: 9, color: '#8e8e93', marginLeft: 6, background: '#f2f2f7', padding: '2px 5px', borderRadius: 4, verticalAlign: 'middle' }}>DESKTOP</span>}
                    </div>
                    <div className="mobile-menu-item-subtitle">{item.subtitle}</div>
                  </div>
                  <ChevronRight size={16} className="mobile-menu-item-chevron" />
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {/* Logout */}
      <button
        className="mobile-action-btn"
        style={{ background: '#f2f2f7', color: '#ff3b30', marginTop: 8 }}
        onClick={() => { alert('Logged out'); }}
      >
        <LogOut size={18} /> Log Out
      </button>
    </div>
  );
}
